<template>
  <div @click="goDetail(obj.id)" class="news_demo hp_flex">
    <div class="left">
      <img :src="base_url + obj.images" alt />
    </div>
    <div class="right hp_flex" style="flex-direction: column;justify-content: space-between;">
      <div>
        <div class="hp_cz_center_s">
          <div class="tag">{{ obj.columnName }}</div>
          <div class="time hp_cz_center">
            <a-icon style="font-size:14px;;margin-right:10px;color:#929292;" type="clock-circle" />
            <span>{{ obj.createTime }}</span>
          </div>
        </div>
        <div class="new_title txt">{{ obj.title }}</div>
        <!-- <div class="intro txt" style="-webkit-line-clamp: 2;">
          {{ obj.subTitle }}
        </div>-->
        <!-- <div
          class="intro txt"
          style="-webkit-line-clamp: 2;"
        >{{ obj.description== obj.title?'': obj.description }}</div> -->
      </div>
      <div class="link hp_cz_center_s">
        <div class="left hp_cz_center">
          <img src="@/assets/index/laiyuan.png" alt />
          <span>来源：{{ obj.source }}</span>
        </div>
        <div class="hp_cz_center">
          <a-icon style="font-size:14px;margin-right:10px;color:#929292;" type="eye" />
          <span>{{ obj.hitCount }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    obj: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    goDetail(id) {
      this.$router.push("/news-bulletin/detail/" + id);
    },
  },
};
</script>
<style lang="less" scoped>
.news_demo {
  cursor: pointer;
  margin-bottom: 25px;
  width: 916px;
  height: 200px;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 0px 9px 0px rgba(127, 188, 255, 0.2);
  padding: 22px 14px 17px 14px;
  .left {
    margin-right: 17px;
    img {
      width: 235px;
      height: 158px;
    }
  }
  .right {
    width: 625px;
    .tag {
      cursor: pointer;
      font-size: 14px;
      font-weight: 400;
      color: #ffffff;
      padding: 5px 17px;
      background: #0079fe;
      border-radius: 16px;
      line-height: 1;
      text-align: center;
    }
    .time {
      font-size: 14px;
      font-weight: 400;
      color: #929292;
      span {
        margin-left: 4px;
        line-height: 3px;
      }
    }
    .new_title {
      margin-top: 12px;
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
      line-height: 36px;
    }
    .intro {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #888888;
      line-height: 28px;
    }
    .link {
      width: 100%;
      span {
        font-size: 14px;
        font-weight: 400;
        color: #888888;
      }
      .left {
        img {
          width: 14px;
          height: 14px;
          margin-right: 12px;
        }
      }
    }
  }
}
.txt {
  max-width: 100%;
  display: -webkit-box;
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; //多行请改这里，2表示最多2行，然后超出自显示省略号
}
</style>
